(() => {
  if (customElements.get('cart-clear-all')) return;

  class CartClearAll extends HTMLElement {
    connectedCallback() {
      const trigger = this.querySelector('button, [role="button"]');
      if (!trigger || this.dataset.bound === 'true') return;
      this.dataset.bound = 'true';
      trigger.addEventListener('click', (e) => this.#onClick(e));
    }

    #onClick(e) {
      e.preventDefault();
      const msg = this.dataset.confirm;
      if (msg && !window.confirm(msg)) return;
      this.#clearCart();
    }

    async #clearCart() {
      const trigger = this.querySelector('button, [role="button"]');
      const root = window.Shopify?.routes?.root ?? '/';
      trigger?.setAttribute('aria-busy', 'true');
      document.documentElement.dispatchEvent(new CustomEvent('theme:loading:start', { bubbles: true }));
      try {
        const response = await fetch(`${root}cart/clear.js`, { method: 'POST' });
        document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: true }));
        if (!response.ok) return;
        if (window.themeVariables?.settings?.pageType === 'cart') {
          window.location.reload();
          return;
        }
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      } catch {
        document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: true }));
      } finally {
        trigger?.removeAttribute('aria-busy');
      }
    }
  }

  customElements.define('cart-clear-all', CartClearAll);
})();
